import { createFileRoute } from '@tanstack/react-router';
import WorkOrdersSemanticGridRoute from '@/features/work-orders/components/WorkOrdersSemanticGridRoute.tsx';

export const Route = createFileRoute('/work-orders/')({
  component: WorkOrdersSemanticGridRoute,
});
